import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalLinkRoutingModule } from './external-links-routing.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ExternalLinkRoutingModule,],
  exports: [RouterModule, ExternalLinkRoutingModule]
})
export class ExternalLinksModule { }
